import type { RedcatAnalyticsStore } from '../types/store';
import { SigninTrackEventName } from '../types/signin';
import type { SigninIdentifierType } from '../types/signin';
import type { SigninTrackEvent } from '../types/events/track';

export const trackSigninInitiated = (
  track: RedcatAnalyticsStore['track'],
  {
    rememberMe,
    identifierType,
  }: {
    rememberMe: boolean;
    identifierType: SigninIdentifierType;
  },
) => {
  const event: SigninTrackEvent = {
    name: SigninTrackEventName.Initiated,
    properties: {
      remember_me: rememberMe,
      identifier_type: identifierType,
    },
  };

  track(event);
};
